if (!customElements.get("trust-indicators-slider")) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();
      const options = JSON.parse(this.getAttribute("data-swiper-options")) || {};
      this.slider = null;
      this.ensureSlider(options);
    }

    ensureSlider(options) {
      const mount = () => {
        if (this.slider) {
          return;
        }
        this.slider = new Swiper(this, {
          slidesPerView: 1.1,
          spaceBetween: options.spaceBetweenMobile || 2,
          breakpoints: {
            750: {
              enabled: true,
              spaceBetween: options.spaceBetweenDesktop || 2,
              slidesPerView: 3,
              loop: false
            }
          }
        });
      };
      const loader = window.themeLibraryLoader;
      if (loader && typeof loader.whenSwiperReady === "function") {
        loader.whenSwiperReady(mount);
      } else if (window.Swiper) {
        mount();
      }
    }
  }

  customElements.define("trust-indicators-slider", TrustIndicatorsSlider);
}
